(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tattoo-portfolio"] && !Shopify.designMode) return;
  try {
    
function tportEscape(s) {
  return String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

function tportRenderGrid(root, picks) {
  const grid = root.querySelector('[data-tport-grid]');
  grid.innerHTML = picks.map((pick, i) => `
    <button type="button" class="tport-item"
       data-tport-index="${i}"
       data-tport-body="${tportEscape((pick.body || []).join(' '))}"
       data-tport-style="${tportEscape((pick.style || []).join(' '))}"
       data-tport-detail="${tportEscape((pick.detail || []).join(' '))}"
       data-tport-sessions="${tportEscape(pick.sessions)}"
       data-tport-flags="${tportEscape((pick.flags || []).join(' '))}">
      <img src="${tportEscape((pick.image_urls || [])[0])}" loading="lazy" alt="">
    </button>`
  ).join('');
}

// Human-readable labels for the tag chips shown above each work's
// description in the lightbox - same codes the filter dropdowns already use
// (see the toolbar markup above), just spelled out instead of raw values
// like "black_detailed". Read from the JSON blob Liquid rendered above (see
// data-tport-i18n) instead of hardcoded here, so the labels come out in
// whatever language the storefront is showing - this file itself is never
// Liquid-processed, so it can't translate anything on its own.
// Same entity-decoding need as the booking form's data-tbf-i18n (see the
// comment on tbfDecodeEntities in tattoo-booking-form.js) - the strings here
// went through Liquid's `t` filter, which HTML-escapes by default, but this
// JSON sits inside a <script> tag that's never parsed as HTML, so the
// escaping never gets undone on its own.
function tportDecodeEntities(value) {
  if (typeof value === 'string') {
    const el = document.createElement('textarea');
    el.innerHTML = value;
    return el.value;
  }
  if (Array.isArray(value)) return value.map(tportDecodeEntities);
  if (value && typeof value === 'object') {
    const out = {};
    for (const k in value) out[k] = tportDecodeEntities(value[k]);
    return out;
  }
  return value;
}
function tportI18n() {
  const el = document.querySelector('[data-tport-i18n]');
  return el ? tportDecodeEntities(JSON.parse(el.textContent)) : { tagLabels: {}, loadError: 'Could not load the portfolio right now - please refresh.' };
}
const TPORT_I18N = tportI18n();
const TPORT_TAG_LABELS = TPORT_I18N.tagLabels;

// Opens the on-site lightbox instead of sending the visitor to Instagram -
// Igor wants people to browse every photo of a post and read its full
// caption without leaving igorklimin.com (see
// business/products/tattoo-booking-form.md). The Instagram link still shows,
// small and optional, at the bottom.
function tportSetupLightbox(root, picks) {
  const lightbox = root.parentElement.querySelector('[data-tport-lightbox]');
  // Reparented to <body> so its `position: fixed` is relative to the actual
  // viewport, not to some ancestor section that happens to have a CSS
  // transform on it (Dawn's scroll-reveal animations do this) - a
  // transformed ancestor creates its own containing block, which is exactly
  // what made the overlay/backdrop only cover part of the page instead of
  // the whole screen.
  document.body.appendChild(lightbox);

  const imgEl = lightbox.querySelector('[data-tport-lightbox-img]');
  const dotsEl = lightbox.querySelector('[data-tport-lightbox-dots]');
  const tagsEl = lightbox.querySelector('[data-tport-lightbox-tags]');
  const captionEl = lightbox.querySelector('[data-tport-lightbox-caption]');
  const igLinkEl = lightbox.querySelector('[data-tport-lightbox-ig-link]');
  const prevBtn = lightbox.querySelector('[data-tport-lightbox-prev]');
  const nextBtn = lightbox.querySelector('[data-tport-lightbox-next]');
  const itemPrevBtn = lightbox.querySelector('[data-tport-lightbox-item-prev]');
  const itemNextBtn = lightbox.querySelector('[data-tport-lightbox-item-next]');

  let currentImages = [];
  let currentIndex = 0;
  let currentButton = null;

  function renderSlide() {
    imgEl.src = currentImages[currentIndex];
    prevBtn.hidden = currentImages.length < 2;
    nextBtn.hidden = currentImages.length < 2;
    dotsEl.hidden = currentImages.length < 2;
    if (currentImages.length > 1) {
      dotsEl.innerHTML = currentImages
        .map((_, i) => `<span class="tport-lightbox-dot${i === currentIndex ? ' active' : ''}"></span>`)
        .join('');
    }
  }

  function visibleButtons() {
    return Array.from(root.querySelectorAll('[data-tport-grid] .tport-item:not([hidden])'));
  }

  function open(button) {
    const pick = picks[Number(button.dataset.tportIndex)];
    if (!pick) return;
    currentButton = button;
    currentImages = pick.image_urls || [];
    currentIndex = 0;
    const tags = [...(pick.body || []), ...(pick.style || []), ...(pick.detail || []), pick.sessions, ...(pick.flags || [])]
      .filter(Boolean)
      .map((code) => TPORT_TAG_LABELS[code] || code);
    tagsEl.innerHTML = tags.map((t) => `<span class="tport-lightbox-tag">${tportEscape(t)}</span>`).join('');
    tagsEl.hidden = tags.length === 0;
    captionEl.textContent = pick.caption || '';
    if (pick.instagram_url) {
      igLinkEl.href = pick.instagram_url;
      igLinkEl.hidden = false;
    } else {
      igLinkEl.hidden = true;
    }
    renderSlide();
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function close() {
    lightbox.hidden = true;
    document.body.style.overflow = '';
  }
  function openAdjacentItem(direction) {
    const list = visibleButtons();
    if (!currentButton || list.length < 2) return;
    const at = list.indexOf(currentButton);
    if (at === -1) return;
    open(list[(at + direction + list.length) % list.length]);
  }

  root.querySelectorAll('[data-tport-grid] .tport-item').forEach((item) => {
    item.addEventListener('click', () => open(item));
  });
  lightbox.querySelectorAll('[data-tport-lightbox-close]').forEach((el) => el.addEventListener('click', close));
  prevBtn.addEventListener('click', () => { currentIndex = (currentIndex - 1 + currentImages.length) % currentImages.length; renderSlide(); });
  nextBtn.addEventListener('click', () => { currentIndex = (currentIndex + 1) % currentImages.length; renderSlide(); });
  itemPrevBtn.addEventListener('click', () => openAdjacentItem(-1));
  itemNextBtn.addEventListener('click', () => openAdjacentItem(1));
  document.addEventListener('keydown', (e) => {
    if (lightbox.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') (currentImages.length > 1 ? prevBtn : itemPrevBtn).click();
    if (e.key === 'ArrowRight') (currentImages.length > 1 ? nextBtn : itemNextBtn).click();
  });
}

// Filtering itself doesn't care whether items were server-rendered or
// fetched in - it just needs the .tport-item elements to already be in the
// grid, so this runs once per root right after tportRenderGrid populates it.
function tportSetupFilters(root) {
  const state = { body: new Set(), style: new Set(), detail: new Set(), sessions: new Set(), options: new Set() };
  const items = Array.from(root.querySelectorAll('[data-tport-grid] .tport-item'));
  const emptyMsg = root.querySelector('[data-tport-empty]');
  const clearBtn = root.querySelector('[data-tport-clear]');

  function anyActive() {
    return state.body.size || state.style.size || state.detail.size || state.sessions.size || state.options.size;
  }

  function applyFilters() {
    let visibleCount = 0;
    items.forEach((item) => {
      const body = item.dataset.tportBody.split(' ').filter(Boolean);
      const style = item.dataset.tportStyle.split(' ').filter(Boolean);
      const detail = item.dataset.tportDetail.split(' ').filter(Boolean);
      const sessions = item.dataset.tportSessions;
      const options = item.dataset.tportFlags.split(' ').filter(Boolean);

      const matches =
        (state.body.size === 0 || body.some((v) => state.body.has(v))) &&
        (state.style.size === 0 || style.some((v) => state.style.has(v))) &&
        (state.detail.size === 0 || detail.some((v) => state.detail.has(v))) &&
        (state.sessions.size === 0 || state.sessions.has(sessions)) &&
        (state.options.size === 0 || options.some((v) => state.options.has(v)));

      item.hidden = !matches;
      if (matches) visibleCount++;
    });
    emptyMsg.hidden = visibleCount > 0;
    clearBtn.hidden = !anyActive();
  }

  root.querySelectorAll('[data-tport-dropdown]').forEach((dropdown) => {
    const filterKey = dropdown.dataset.filter;
    const toggle = dropdown.querySelector('[data-tport-toggle]');
    const menu = dropdown.querySelector('[data-tport-menu]');

    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const willOpen = !menu.classList.contains('open');
      root.querySelectorAll('.tport-menu.open').forEach((m) => m.classList.remove('open'));
      if (willOpen) {
        const rect = toggle.getBoundingClientRect();
        const menuWidth = 220;
        let left = rect.left;
        left = Math.max(8, Math.min(left, window.innerWidth - menuWidth - 8));
        menu.style.left = left + 'px';
        menu.style.top = (rect.bottom + 6) + 'px';
        menu.classList.add('open');
      }
    });

    menu.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((box) => {
      box.addEventListener('change', () => {
        if (box.type === 'radio') state[filterKey].clear();
        if (box.checked) state[filterKey].add(box.value);
        else state[filterKey].delete(box.value);
        toggle.classList.toggle('tport-chip--active', state[filterKey].size > 0);
        applyFilters();
      });
    });
  });

  clearBtn.addEventListener('click', () => {
    Object.values(state).forEach((set) => set.clear());
    root.querySelectorAll('.tport-menu input').forEach((box) => (box.checked = false));
    root.querySelectorAll('.tport-chip--active').forEach((chip) => chip.classList.remove('tport-chip--active'));
    applyFilters();
  });

  document.addEventListener('click', (e) => {
    if (!root.contains(e.target)) return;
    if (!e.target.closest('[data-tport-dropdown]')) {
      root.querySelectorAll('.tport-menu.open').forEach((m) => m.classList.remove('open'));
    }
  });

  // The menu is `position: fixed`, positioned once (relative to the screen)
  // at the moment it opens. Scrolling the page then leaves it visually
  // stranded, floating over unrelated content instead of following its
  // button - simplest fix is to just close it as soon as the page scrolls,
  // same as most native dropdowns/menus behave.
  document.addEventListener(
    'scroll',
    (e) => {
      if (e.target instanceof Element && e.target.closest('.tport-menu')) return;
      root.querySelectorAll('.tport-menu.open').forEach((m) => m.classList.remove('open'));
    },
    true
  );
}

document.querySelectorAll('.tport-wrap').forEach((root) => {
  const workerUrl = root.dataset.tportWorkerUrl;
  const emptyMsg = root.querySelector('[data-tport-empty]');
  fetch(`${workerUrl}/portfolio`)
    .then((r) => r.json())
    .then((picks) => {
      const list = Array.isArray(picks) ? picks : [];
      tportRenderGrid(root, list);
      tportSetupFilters(root);
      tportSetupLightbox(root, list);
      if (!list.length) emptyMsg.hidden = false;
    })
    .catch(() => {
      emptyMsg.textContent = TPORT_I18N.loadError;
      emptyMsg.hidden = false;
    });
});

  } catch(e) { console.error(e); }
})();
})();
